import React, { useState } from 'react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'SaaS Products', href: '#products' },
    { name: 'Services', href: '#services' },
    { name: 'AI Workflows', href: '#ai-solutions' },
    { name: 'Dashboards', href: '#dashboards' },
    { name: 'Industries', href: '#industries' },
    { name: 'Why Us', href: '#why-us' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-slate-950/90 backdrop-blur-md border-b border-slate-800 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#" className="flex items-center">
            <Logo size="md" textColor="white" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-xs font-semibold text-slate-300 hover:text-blue-400 transition-colors uppercase tracking-wider"
              >
                {link.name}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="/empaques"
              className="inline-flex items-center gap-1.5 bg-slate-900 hover:bg-slate-800 text-blue-400 hover:text-blue-300 font-semibold text-xs px-3.5 py-2.5 rounded-xl border border-blue-500/40 transition-all shadow-sm"
              title="Portal de Pedidos de Empaques Automotrices"
            >
              <span>📦</span>
              <span>Portal Empaques</span>
            </a>
            <a
              href="#contact"
              className="bg-blue-600 hover:bg-blue-500 text-white font-semibold text-xs px-5 py-2.5 rounded-xl transition-all shadow-md shadow-blue-600/30"
            >
              Get Free Audit
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-900 focus:outline-none"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-slate-900 border-b border-slate-800 px-4 pt-2 pb-6 space-y-3">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setMobileMenuOpen(false)}
              className="block text-sm font-semibold text-slate-200 hover:text-blue-400 py-2 border-b border-slate-800/60"
            >
              {link.name}
            </a>
          ))}
          <a
            href="/empaques"
            onClick={() => setMobileMenuOpen(false)}
            className="flex items-center gap-2 text-sm font-semibold text-blue-400 hover:text-blue-300 py-2 border-b border-slate-800/60"
          >
            <span>📦</span>
            <span>Portal Empaques Automotrices</span>
          </a>
          <a
            href="#contact"
            onClick={() => setMobileMenuOpen(false)}
            className="block text-center bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm py-3 rounded-xl mt-4"
          >
            Get Free Audit
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
